<!-- Container for the page -->
<div class="w-full min-h-screen bg-black flex flex-col items-center">

    <!-- Header bar -->
    <div class="relative w-full h-[64px] flex px-[38px] items-center bg-black z-20">
        <div class="flex h-[48px] justify-center items-center gap-[10px]">
            <img src="png/ArrowLeft.svg" alt="icon" (click)="onBack()" class="object-contain w-[24px] h-[24px] cursor-pointer">
            <h2 class="text-[#FCFCFD] font-manrope text-[18px] font-bold leading-[120%]">
                {{'Premium calculation' | translate}}
            </h2>
        </div>
    </div>


    <div class="w-full flex flex-col items-center mt-6 px-4 relative">
        <h1 class="text-start text-[#FCFCFD] font-manrope text-[24px] font-medium leading-[130%] max-w-[600px]">
            {{'Instant premium check – long-term peace of mind' | translate}}
        </h1>
        <!-- Subtle horizontal line -->
        <hr class="w-[327px] border-t border-[rgba(217,217,217,0.12)] mt-12 mb-12" />
        <form [formGroup]="form" class="w-full gap-6">

            <!-- Insurance Type -->
            <div class="shadow-lg mx-auto mb-4 rounded-lg max-w-md">
                <label class="block mb-2 text-slate-white text-base">
                    {{'Select Insurance Type' | translate}}
                </label>
                <div class="relative dropdown-container">
                    <button type="button"
                        class="bg-[#18171A] shadow px-4 py-3 border-none rounded-xl focus:outline-none w-full text-white text-left"
                        (click)="toggleDropdown('insurance', $event)">
                        <span class="text-slate-300">
                            {{ form.get('insuranceType')?.value || ('Insurance plan you interested' | translate) }}
                        </span>
                        <span class="float-right">&#9662;</span>
                    </button>
                    <div *ngIf="activeDropdown === 'insurance'"
                        class="z-10 absolute bg-[#18171A] shadow-lg mt-2 border border-[#232124] rounded-xl w-full max-h-60 overflow-y-auto">
                        <div *ngFor="let insurance of insurance"
                            (click)="form.get('insuranceType')?.setValue(insurance); closeDropdown(); $event.stopPropagation()"
                            class="hover:bg-[#232124] px-4 py-2 rounded-xl cursor-pointer"
                            [ngClass]="insurance === form.get('insuranceType')?.value ? 'text-[#F03457] font-semibold' : 'text-white'">
                            {{ insurance | translate }}
                        </div>
                    </div>
                </div>
                <div *ngIf="form.get('insuranceType')?.invalid && (form.get('insuranceType')?.touched || form.get('insuranceType')?.dirty)"
                    class="mt-1 text-[#F03457] text-sm">
                    <span *ngIf="form.get('insuranceType')?.errors?.['required']">{{'Insurance type is required.' |
                        translate}}</span>
                </div>
            </div>
            <!-- Contract Type -->
            <div class="shadow-lg mx-auto mb-4 rounded-lg max-w-md">
                <label class="block mb-2 text-slate-white text-base">
                    {{'Contract Type' | translate}}
                </label>
                <div class="relative dropdown-container">
                    <button type="button"
                        class="bg-[#18171A] shadow px-4 py-3 border-none rounded-xl focus:outline-none w-full text-white text-left"
                        (click)="toggleDropdown('contract', $event)">
                        <span class="text-slate-300">
                            {{ form.get('contractType')?.value || ('Your contract type' | translate) }}
                        </span>
                        <span class="float-right">&#9662;</span>
                    </button>
                    <div *ngIf="activeDropdown === 'contract'"
                        class="z-10 absolute bg-[#18171A] shadow-lg mt-2 border border-[#232124] rounded-xl w-full max-h-60 overflow-y-auto">
                        <div *ngFor="let con of contract"
                            (click)="form.get('contractType')?.setValue(con); closeDropdown(); $event.stopPropagation()"
                            class="hover:bg-[#232124] px-4 py-2 rounded-xl cursor-pointer"
                            [ngClass]="con === form.get('contractType')?.value ? 'text-[#F03457] font-semibold' : 'text-white'">
                            {{ con | translate }}
                        </div>
                    </div>
                </div>
                <div *ngIf="form.get('contractType')?.invalid && (form.get('contractType')?.touched || form.get('contractType')?.dirty)"
                    class="mt-1 text-[#F03457] text-sm">
                    <span *ngIf="form.get('contractType')?.errors?.['required']">{{'Contract type is required.' |
                        translate}}</span>
                </div>
            </div>

            <!-- Age -->
            <div class="shadow-lg mx-auto mb-4 rounded-lg max-w-md">
                <label class="block mb-2 text-slate-white text-base">
                    {{'Age' | translate}}
                </label>
                <div class="relative dropdown-container">
                    <button type="button"
                        class="bg-[#18171A] shadow px-4 py-3 border-none rounded-xl focus:outline-none w-full text-white text-left"
                        (click)="toggleDropdown('age', $event)">
                        <span class="text-slate-300">
                            {{ form.get('age')?.value || ('Your age' | translate) }}
                        </span>
                        <span class="float-right">&#9662;</span>
                    </button>
                    <div *ngIf="activeDropdown === 'age'"
                        class="z-10 absolute bg-[#18171A] shadow-lg mt-2 border border-[#232124] rounded-xl w-full max-h-60 overflow-y-auto">
                        <div *ngFor="let ageItem of age"
                            (click)="form.get('age')?.setValue(ageItem); closeDropdown(); $event.stopPropagation()"
                            class="hover:bg-[#232124] px-4 py-2 rounded-xl cursor-pointer"
                            [ngClass]="ageItem === form.get('age')?.value ? 'text-[#F03457] font-semibold' : 'text-white'">
                            {{ ageItem }}
                        </div>
                    </div>
                </div>
                <div *ngIf="form.get('age')?.invalid && (form.get('age')?.touched || form.get('age')?.dirty)"
                    class="mt-1 text-[#F03457] text-sm">
                    <span *ngIf="form.get('age')?.errors?.['required']">{{'Age is required.' | translate}}</span>
                </div>
            </div>

            <!-- Gender Selection -->
            <div class="shadow-lg mx-auto mb-4 rounded-lg max-w-md">
                <label class="block mb-2 text-slate-white text-base">{{'What is your gender?' | translate}}</label>
                <div class="flex items-center gap-2 mb-3">
                    <label
                        class="flex justify-center items-center px-6 py-2 border rounded-full font-medium text-[14px] text-gray-300 cursor-pointer"
                        [ngClass]="{'border-secondary text-secondary': form.get('gender')?.value === 'MALE'}">
                        <input type="radio" formControlName="gender" value="MALE" class="hidden" />{{'MALE' |
                        translate}}
                    </label>
                    <label
                        class="flex justify-center items-center px-6 py-2 border rounded-full font-medium text-[14px] text-gray-300 cursor-pointer"
                        [ngClass]="{'border-secondary text-secondary': form.get('gender')?.value === 'FEMALE'}">
                        <input type="radio" formControlName="gender" value="FEMALE" class="hidden" />{{'FEMALE' |
                        translate}}
                    </label>
                </div>
                <div *ngIf="form.get('gender')?.invalid && (form.get('gender')?.touched || form.get('gender')?.dirty)"
                    class="mt-1 text-[#F03457] text-sm">
                    <span *ngIf="form.get('gender')?.errors?.['required']">{{'Gender is required.' | translate}}</span>
                </div>
            </div>


            <!-- Submit Button -->
            <div class="right-0 bottom-0 left-0 z-20 fixed bg-[#141011] p-4 w-full">
                <button type="button" (click)="onSubmit()"
                    class="px-3 py-4 rounded-[4px] w-full font-primary font-bold text-lg transition-all duration-300 flex justify-center items-center gap-2"
                    [ngClass]="{
              'bg-secondary text-white': !form.invalid && !isLoading,
              'bg-[#5A5657] text-gray-200': form.invalid || isLoading
            }">
                    <span *ngIf="!isLoading">{{ 'Calculate premium' | translate }}</span>

                    <span *ngIf="isLoading" class="flex items-center gap-2">
                        <svg class="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none"
                            viewBox="0 0 24 24">
                            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4">
                            </circle>
                            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
                        </svg>
                        {{'Loading...' | translate}}
                    </span>
                </button>
            </div>
        </form>
    </div>
</div>